export const qualityInspectionData = [
    {
        id: 1,
        name: "Pièce A",
        inspector: "Jean Dupont",
        status: "En attente",
    },
    {
        id: 2,
        name: "Pièce B",
        inspector: "Marie Curie",
        status: "En attente",
    },
    {
        id: 3,
        name: "Pièce C",
        inspector: "Paul Martin",
        status: "Non conforme",
    },
];
